module.exports = __webpack_public_path__ + "img/linkedin.17a4cc44.svg";